// src/services/deviceService.js
// Per-device credential management for the Cartelería admin UI.
// Wraps:
//   - GET    /apitest/api/devices              (list) — used by the health card
//   - POST   /apitest/api/devices/:id/heartbeat (admin-initiated JWT re-mint)
//
// The health card actually pulls device rows from getSignageHealth() (single
// round-trip). listDeviceCredentials() is here for callers that need the raw
// row set without the status badges / enrichment.

import axios from 'axios';
import { NODE_BACKEND_API_URL } from '../config';

const DEVICES_BASE = `${NODE_BACKEND_API_URL}/api/devices`;

export const listDeviceCredentials = async () => {
    const response = await axios.get(DEVICES_BASE);
    return response.data;
};

export const heartbeatDevice = async (deviceId) => {
    const response = await axios.post(`${DEVICES_BASE}/${deviceId}/heartbeat`);
    return response.data;
};
